import React, { useEffect, useState } from 'react';
import { Link, useOutletContext, useSearchParams } from 'react-router-dom';
import styles from './ExternalPortal.module.scss';
import backgroundImage from '../../Assets/Images/background.svg';
import { useTranslate } from 'react-polyglot';
import { ExternalLayoutContext } from './ExternalLayout';
import { useAxios } from '../../AxiosHandler';

// Statistics is only released for Grosser (341) and Kleiner (342) Munsterlander
// so far - those are the breeds DOG.V_TEST_PRIZE_PER_YEAR has a source for.
// ExternalStatistics guards on the same list.
export const STATISTICS_BREED_IDS = ['341', '342'];

function ExternalPortal() {
    const t = useTranslate();
    const [searchParams] = useSearchParams();
    const { setBackLink } = useOutletContext<ExternalLayoutContext>();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [breedregSchemaId, setBreedregSchemaId] = useState<string | null>(null);
    const [malepartnerreqSchemaId, setMalepartnerreqSchemaId] = useState<string | null>(null);

    const breedId = searchParams.get('r');

    useEffect(() => {
        setBackLink(undefined);
    }, []);

    useEffect(() => {
        if (!breedId) return;
        axios.single({ method: 'get', url: `/api/dynschema/special/${breedId}/breedreg/${breedId}`, responseType: 'json' })
            .then((res: any) => { if (res.data?.ID) setBreedregSchemaId(res.data.ID); })
            .catch(() => {});
        axios.single({ method: 'get', url: `/api/dynschema/special/${breedId}/malepartnerreq/${breedId}`, responseType: 'json' })
            .then((res: any) => { if (res.data?.ID) setMalepartnerreqSchemaId(res.data.ID); })
            .catch(() => {});
    }, [breedId]);

    return (
        <div 
            className={styles.externalPortal}
            style={{ '--background-image': `url(${backgroundImage})` } as React.CSSProperties}
        >
            <div className={styles.backgroundTail}></div>
            
            <div className={styles.mainContent}>
                <div className={styles.optionsGrid}>
                    <Link to={`/external/breeding?${searchParams.toString()}`} className={styles.optionCard}>
                        <div className={styles.optionIcon}>
                            <i className="fas fa-paw"></i>
                        </div>
                        <h2>{t("externalportal.breeding.title")}</h2>
                        <p>{t("externalportal.breeding.description")}</p>
                    </Link>
                    
                    <Link to={`/external/puppies?${searchParams.toString()}`} className={styles.optionCard}>
                        <div className={styles.optionIcon}>
                            <i className="fas fa-baby"></i>
                        </div>
                        <h2>{t("externalportal.puppylist.title")}</h2>
                        <p>{t("externalportal.puppylist.description")}</p>
                    </Link>

                    <Link to={breedregSchemaId ? `/skjema/dyn/${breedId}/${breedregSchemaId}` : '#'} target="_blank" rel="noreferrer" className={styles.optionCard}>
                        <div className={styles.optionIcon}>
                            <i className="fas fa-certificate"></i>
                        </div>
                        <h2>{t("externalportal.approvaldog.title")}</h2>
                        <p>{t("externalportal.approvaldog.description")}</p>
                    </Link>

                    <Link to={malepartnerreqSchemaId ? `/skjema/dyn/${breedId}/${malepartnerreqSchemaId}` : '#'} target="_blank" rel="noreferrer" className={styles.optionCard}>
                        <div className={styles.optionIcon}>
                            <i className="fas fa-heart"></i>
                        </div>
                        <h2>{t("externalportal.approvalmating.title")}</h2>
                        <p>{t("externalportal.approvalmating.description")}</p>
                    </Link>

                    {STATISTICS_BREED_IDS.includes(breedId ?? '') &&
                        <Link to={`/external/statistics?${searchParams.toString()}`} className={styles.optionCard}>
                            <div className={styles.optionIcon}>
                                <i className="fas fa-chart-bar"></i>
                            </div>
                            <h2>{t("externalportal.statistics.title")}</h2>
                            <p>{t("externalportal.statistics.description")}</p>
                        </Link>
                    }
                </div>
                
                <div className={styles.faqRow}>
                    <Link to={`/external/faq?${searchParams.toString()}`} className={styles.optionCard}>
                        <div className={styles.optionIcon}>
                            <i className="fas fa-question-circle"></i>
                        </div>
                        <h2>{t("externalportal.faq.title")}</h2>
                        <p>{t("externalportal.faq.description")}</p>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ExternalPortal;
